module.exports = {"440882001":"雷城街道办","440882002":"西湖街道办","440882003":"新城街道办","440882100":"白沙镇","440882101":"沈塘镇","440882102":"客路镇","440882103":"杨家镇","440882104":"唐家镇","440882105":"企水镇","440882106":"纪家镇","440882107":"松竹镇","440882108":"南兴镇","440882109":"雷高镇","440882110":"东里镇","440882111":"调风镇","440882112":"龙门镇","440882113":"英利镇","440882114":"北和镇","440882115":"乌石镇","440882116":"覃斗镇","440882117":"附城镇","440882450":"湛江奋勇高新技术产业开发区管理委员会","440882451":"广东省丰收糖业发展有限公司","440882452":"广东省火炬农场","440882453":"广东省幸福农场","440882454":"湛江农垦东方红农场","440882455":"湛江农垦金星农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440882.json
// module id = 2004
// module chunks = 0